import { BaseComponent } from "./base-component";
import API, { ElongAPI, ERR_TOKEN_INVALID, SYSTEM_UP_GRADE } from "./api";
import { Session, Local, isFunction, convertWXLngLat, queryPositonCity, getUrlParameterByName } from "./utils";
import docCookies from './utils/cookie';
import Wechat from "./utils/wechat";
import { COMPONENT } from "./ui-event/index";

export class PageComponent extends BaseComponent {

  WECHAT_JSSDK_DEBUG = process.env.REACT_APP_WECHAT_DEBUG === "true";

  // 微信权限列表，需要在.config的时候提供
  WECHAT_JSSDK_JSAPI_LIST = [
    'chooseImage',
    'previewImage',
    'uploadImage',
    'onMenuShareTimeline',
    'onMenuShareAppMessage',
    'onMenuShareQQ',
    'onMenuShareWeibo',
    'onMenuShareQZone',
    'getLocation',
    'chooseWXPay'
  ];

  /**
   * 每个页面必须执行的构造函数 （如果没执行，第一个参数为props，第二个参数为{}）
   * @param {*} pageName 当前页面的名称，自定义，主要用于存储session storage的key name
   * @param {*} wechatSetupSuccess 微信config成功之后回调
   * @param {*} initShare 是否开启微信分享初始化功能
   */
  constructor(pageName, wechatSetupSuccess, initShare = true, initPosition = false) {
    super();

    this.pageName = pageName;
    this.apiMgr = API;
    this.ElongAPI = ElongAPI;
    // 暂时在页面初始化的时候设置token，以后改为监听localstorage 的token变化而设置
    this.apiMgr.setToken(Local.get(LOCAL_KEYS.TOKEN));

    // 每个需要加载jssdk的页面 需要显示loading 在加载完成之后取消loading 开发环境不用加载jssdk
    if (!window.isWx) return

    // this.eventMgr.emit('COMPONENT_LOADING_TOGGLE', true)
    this.wechat = new Wechat(async () => {
      // this.eventMgr.emit('COMPONENT_LOADING_TOGGLE', false)

      // 初始分享参数
      if (initShare) {
        await this.share();
        this.shareWithMp()
      }

      // 获取用户定位
      initPosition && await this.location();

      // 抛出给页面的回调 兼容 没有给constructor传参的页面
      isFunction(wechatSetupSuccess) && wechatSetupSuccess()
    });
  }

  /**
   * 在登出后，自动移除api token
   */
  removeAPIToken() {
    this.apiMgr.removeToken()
  }

  // 获取openId
  getOpenId() {
    // return this.restoreInLocal(LOCAL_KEYS.OPENID)
    return docCookies.getItem('openId');
  }

  /**
   * 用于保存页面的数据，建议在componentWillUmount上调用
   * 数据会存在sessionStorage里面，并根据constructor提供的pageName作为Key
   * @param {*} pageState
   */
  hold(pageState) {
    if (this.pageName) {
      Session.set(this.pageName, pageState);
    }
  }

  /**
   * 用于恢复页面的数据，建议在componentDidMount上调用(因为如果在willUmount中存储的，willMount中无法获取)
   * 数据会取出于sessionStorage里面
   */
  restore() {
    if (this.pageName) {
      return Session.get(this.pageName);
    }
  }

  /**
   * 将数据缓存在sessionStorage
   * @param {*} globalKey 从PageComponent的 GLOBAL_SESSION_KEYS 定义
   * @param {*} globalValue
   */
  holdInGlobal(globalKey, globalValue) {
    Session.set(globalKey, globalValue);
  }

  /**
   * 让数据从sessionStorage恢复
   * @param {*} globalKey
   */
  restoreInGlobal(globalKey) {
    return Session.get(globalKey);
  }

  /**
   * 删除Session数据
   * @param {*} key
   */
  removeInSession(globalKey) {
    return Session.remove(globalKey);
  }

  /**
   * 当退出一个页面时，需要丢弃当前页面所有状态的时候调用
   */
  finish() {
    if (this.pageName) {
      Session.remove(this.pageName);
    }
  }

  /**
   * 将数据缓存在localStorage
   * @param {*} key
   * @param {*} value
   * @param {Number} expire 过期时间，timestamp
   */
  holdInLocal(key, value, expire) {
    Local.set(key, value, expire);
  }

  /**
   * 让数据从localStorage恢复
   * @param {*} globalKey
   */
  restoreInLocal(key) {
    return Local.get(key);
  }

  /**
   * 获取当前定位的高德坐标
   * @returns 坐标
   */
  getCoordinate() {
    return new Promise(async (resolve, reject) => {
      try {
        // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
        let { longitude, latitude } = await this.wechat.invoke('getLocation', { type: 'wgs84' });
        let { AMaplongitude, AMaplatitude } = await convertWXLngLat(longitude, latitude);
        resolve({ AMaplongitude, AMaplatitude })
      } catch (error) {
        reject(error);
      }
    })
  }


  /**
   * 移除localStorage某项数据
   * @param {*} key
   */
  removeInLocal(key) {
    Local.remove(key);
  }

  /**
   * 调用API
   * @param {function} call e.g. ()=>this.apiMgr.YOU_NEED_API_FUNC()
   * @param {boolean} isElong 是否为艺龙接口
   */
  apiInvoke(call, noLoading, isElong) {
    const api = this.apiMgr;
    const elongApi = this.ElongAPI;
    /**
     * 统一处理通用的请求错误，如token失效，gateway升级中 等
     * TODO 添加通用请求错误内容
     */
    const handleNetWorkError = ({ retCode, msg, data }, reject) => {
      switch (retCode) {
        case ERR_TOKEN_INVALID:
          //token 失效 清除 1、token 2、用户信息
          this.removeInLocal('token');
          this.removeInLocal('user');
          // TOKEN 失效 进入登陆页面
          // this.props.history.push("/login");
          this.props.history.push({
            pathname:"/login",
            from: this.props.location
          });
          break;
        case SYSTEM_UP_GRADE:
          //系统升级中
          this.props.history.push("/system-upgrade");
          break;
        default:
          reject({ retCode, msg, data });
          break;
      }
    };
    if (!noLoading) this.eventMgr.emit(COMPONENT.LOADING.TOGGLE, true);
    return new Promise(async (resolve, reject) => {
      let respData = {};
      if(isElong){
        const { data } = await call(elongApi);
        respData = data
      }else{
        const { data } = await call(api);
        respData = data
      }
      if (!noLoading)
        // 临时需求 去除loading延迟关闭功能
        // setTimeout(() => {
          this.eventMgr.emit(COMPONENT.LOADING.TOGGLE, false);
        // }, 1000);
      if (respData.retCode && respData.retCode != 200) {
        // 如果有retCode表示请求有异常
        handleNetWorkError(respData, reject);
      } else {
        resolve(respData);
      }
    });
  }

  /**
   * 显示toast内容
   * @param {*} content toast内容
   */
  toast(content) {
    this.eventMgr.emit(COMPONENT.TOAST.POPUP, content)
  }

  //设置分享
  async share(shareParams = {
    title: 'Xbed互联网酒店，不一样的商旅居住体验！',
    desc: '温暖、自由、联通',
    link: process.env.REACT_APP_URL + 'app/home',
    imgUrl: process.env.REACT_APP_URL + 'icon-default.jpg',
  }) {
    //TODO 分享配置需要调整
    // const defaultParams = {
    //   title: 'Xbed互联网酒店，不一样的商旅居住体验！',
    //   desc: '温暖、自由、联通',
    //   link: process.env.REACT_APP_URL + 'app/home',
    //   imgUrl: process.env.REACT_APP_URL + 'icon-default.jpg',
    // }
    //...结构 bull undefined 不会报错  Object.assign({}, underfined) 会报错
    // let commitShareParams = { ...defaultParams, ...shareParams};

    await this.wechat.invoke('onMenuShareTimeline', shareParams, true);
    await this.wechat.invoke('onMenuShareAppMessage', shareParams, true);
    await this.wechat.invoke('onMenuShareQQ', shareParams, true);
    await this.wechat.invoke('onMenuShareWeibo', shareParams, true);
    await this.wechat.invoke('onMenuShareQZone', shareParams, true);

  }

  /**
   * 小程序分享（转发）的配置
   * @param path 小程序路由地址
   */
  shareWithMp(mpShareParams = {
    title: 'Xbed互联网酒店，不一样的商旅居住体验！',
    path: `pages/home/main?webUrl=${encodeURIComponent(process.env.REACT_APP_URL + 'app/home')}`,
    imageUrl: process.env.REACT_APP_URL + 'icon-default.jpg',
  }) {
    if (window.isMiniprogram) {
      window.wx.miniProgram.postMessage({ data: mpShareParams })
    }
  }

  //设置定位信息
  location() {
    return new Promise(async (resolve, reject) => {
      try {
        // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
        let { longitude, latitude } = await this.wechat.invoke('getLocation', { type: 'wgs84' });
        // 将通过微信jssdk获取的经纬度转换成高德地图的经纬度
        let { AMaplongitude, AMaplatitude } = await convertWXLngLat(longitude, latitude)
        // 将高德经纬度转化为对应城市，逆地理编码
        let city = await queryPositonCity(AMaplongitude, AMaplatitude);

        this.holdInLocal("position-city", city)
        this.holdInLocal("longitude", AMaplongitude)
        this.holdInLocal("latitude", AMaplatitude)
        this.holdInLocal("postLongitude", AMaplongitude)
        this.holdInLocal("postLatitude", AMaplatitude)
        resolve()
      } catch (error) {
        console.error('微信初始化定位失败', JSON.stringify(error))
        reject(error)
      }
    })
  }

  /**
   * 这个接口的功能为是获取卡卷（活动）到期未读提醒数量 大于0显示 等于零不显示显示小红点
   */
  async findCardCount() {
    const user = this.restoreInLocal('user');
    const token = this.restoreInLocal(LOCAL_KEYS.TOKEN);

    if (!user && !token) return;
    try {
      const { count } = await this.apiInvoke(() => this.apiMgr.findCardCount());
      this.eventMgr.emit(COMPONENT.NAV_MINE_DOT.TOGGLE, count);
    } catch (error) {
      this.toast(error.msg);
    }
  }

  /**
   * 分享链接回跳定向
   */
  ShareRouteBack = () => {
    const beFrom = getUrlParameterByName('beFrom');
    //如果是分享链接，
    if (beFrom === 'share') {
      this.props.history.push('/app/home');

      //如果不是分享链接，按原操作跳转路由
    } else {
      this.props.history.goBack();
    }
  }
}

// 全局session
export const GLOBAL_SESSION_KEYS = {
  CITY: "city",
  STARTDATE: "start-date",
  ENDDATE: "end-date",
  INVOICE_ORDERS_DATA: "invoice_orders_data",
  ROOMLIST_PARAM: "roomlist-param",
  ROOMLIST_DISTRICT: "roomlist-district",
  ROOMLIST_TRAGDINGAREA: "roomlist-tradingArea",
  ROOMLIST_ROOMFEATURETAG: "roomlist-roomFeaturTag",
  ROOMLIST_ROOMLIST: "roomlist-roomList",
  ROOMLIST_CHAINLIST: "roomlist-chainList",
  CLEAN_INFO: "clean_info",
  CHECKINER_INFO: "checkiner_info",
  WECHAT_CONFIG: "wechat-config",
  // 微信支付参数
  WECHAT_PAY_PARAMS: "wechat_pay_params",

  // 银联支付参数
  UNION_PAY_PARAMS: "union_pay_params",

  // 寻路指引
  PATH_FIND_DATA: "path_find_data",

  //预定页存储参数 navigation
  BOOK_CANCEL_PAY_BACK_URL: "book_cancel_pay_back_url"
};

export const LOCAL_KEYS = {
  CITY: "city",
  TOKEN: "token",
  USER: "user",
  CITY_LIST: "city-list",
  CITY_HISTORY: "city-history",
  CITY_HISTORYDATA: "city-historyData",
  CITY_CODE:'city_code',
  // OPENID: "openId",
  LONGITUDE: "longitude",
  LATITUDE: "latitude",
  POSITION_CITY: "position-city",
  POSITION_CITY_CODE: 'position-city-code',
  POSITION_LONGITUDE: "postLongitude",
  POSITION_LATITUDE: 'postLatitude',
};



// WEBPACK FOOTER //
// ./src/page-component.js